import { Box, Button, IconButton, Modal, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModalBox } from "../guidedSelling/styledComponents";

export const ConfirmationDailog = ({
	isOpen,
	title,
	sx={},
	body,
	handleClose,
	cancelBtnText,
	confirmBtnText,
	onCancel,
	onConfirm,
	confirmBtnColor
}) => {
	const theme = useTheme();
	const confirmBtnColour = confirmBtnColor === "primary" ? theme.palette.primary.main : theme.palette.primary.danger
	return (
		<Modal open={isOpen} onClose={handleClose}>
			<ModalBox sx={sx}>
				<Box display="flex" justifyContent="space-between" >
					<Typography fontSize={20} color={theme.palette.text.main}>
						{title}
					</Typography>
					<IconButton
						sx={{
							minWidth: 40,
							maxWidth: 40,
							padding: 0,
							color: theme.palette.primary.main
						}}
						size="medium"
						onClick={handleClose}
					>
						<CloseIcon />
					</IconButton>
				</Box>
				<Typography
					sx={{
						mt: 2,
						fontSize: "14px",
						lineHeight: "20px",
						color: theme.palette.text.main,
						whiteSpace: "pre-wrap"
					}}
				>
					{body}
				</Typography>
				<Box display="flex" justifyContent="space-between" mt={4}>
					<Button
						variant="text"
						sx={{
							padding: 0,
							fontWeight: 600,
							fontSize: "14px",
							color: theme.palette.primary.main,
							textTransform: "none"
						}}
						onClick={onCancel}
					>
						{cancelBtnText}
					</Button>
					<Button
						variant="contained"
						onClick={onConfirm}
						sx={{
							height: "40px",
							borderRadius: "6px",
							fontWeight: 600,
							boxShadow: "none",
							backgroundColor: confirmBtnColour,
							borderColor: confirmBtnColour,
							"&:hover": {
								backgroundColor: confirmBtnColour,
								boxShadow: "none"
							},
							color: theme.palette.text.showMore,
							textTransform: "none"
						}}
					>
						{confirmBtnText}
					</Button>
				</Box>
			</ModalBox>
		</Modal>
	);
};
